import { skillCategory } from '@/api/common/master-lists'

export default {
  namespaced: true,
  state () {
    return {
      loading: false,
      items: sessionStorage.getItem('skillCategories')
        ? JSON.parse(sessionStorage.getItem('skillCategories'))
        : []
    }
  },
  mutations: {
    /**
     * Set the items.
     *
     * @param {*} state
     * @param {*} items
     */
    SET_ITEMS (state, items) {
      state.items = items
    },
    /**
     * Set the status.
     *
     * @param {*} state
     * @param {*} items
     */
    SET_LOADING (state, loading) {
      state.loading = loading
    }
  },
  actions: {
    /**
     * Fetch all SkillCategory records.
     *
     * @param { commit, dispatch, state}
     */
    fetch ({ commit, dispatch, state }) {
      if (state.items.length) return

      commit('SET_LOADING', true)

      return skillCategory.index()
        .then(({ data }) => {
          commit('SET_ITEMS', data)

          sessionStorage.setItem('skillCategories', JSON.stringify(data))
        })
        .catch(({ response }) => {
          dispatch('httpException/handle', response, { root: true })
        })
        .finally(() => {
          commit('SET_LOADING', false)
        })
    }
  }
}
